// constant key for screenshot
export const FORM_SCREENSHOT_KEY = 'considarScreenshot';
// the name for the model key for submitting the current model information
export const MODEL_NAME_KEY = 'selectedModelName';
export const MODEL_MATERIALS_KEY = 'selectedMaterialNames';
